import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

const handlerSubmit = (e) => {
  e.preventDefault();
  const validity = document.querySelector('form[data-timeslots]').checkValidity();
  if (validity) {
    const data = createString(document.querySelector('form[data-timeslots]'));
    if (data) {
      sendData(data);
    }
  }
};

const sendData = (data) => {
  const action = document.querySelector('form[data-timeslots]').getAttribute('action');
  let bodyFormData = new FormData();
  bodyFormData.append('parameters_config[value_string]', JSON.stringify(data));
  apiConnector()({
    method: 'put',
    url: action,
    data: bodyFormData,
  }).then((success) => {
    document.querySelector('[data-timeslots]').setAttribute('data-timeslots', JSON.stringify(data));
    eventBus.$emit('updateTimeSlot', data);
  });
};

const createString = (target) => {
  let oldValues = JSON.parse(document.querySelector('[data-timeslots]').getAttribute('data-timeslots'));
  const results = daySelected(document.querySelector('*[data-scope=dom-days]'));
  const start = defineInterval(target, '*[name=start_interval_h]', '*[name=start_interval_m]');
  const end = defineInterval(target, '*[name=end_interval_h]', '*[name=end_interval_m]');
  const interval = {
    start_interval: `${start.start_interval}:${start.end_interval}`,
    end_interval: `${end.start_interval}:${end.end_interval}`,
    type: target.querySelector('*[name=day]').classList.contains('selected') ? 'day' : 'night',
  };
  const currentStartMinutes = parseInt(start.start_interval) * 60 + parseInt(start.end_interval);
  const currentEndMinutes = parseInt(end.start_interval) * 60 + parseInt(end.end_interval);

  if (currentEndMinutes <= currentStartMinutes) return false;

  let newValues = results.map((day) => {
    return {
      ...day,
      ...interval,
    };
  });
  return [...oldValues, ...newValues];
};

const daySelected = (days) => {
  let results = [];
  for (let i = 0; i < days.options.length; i++) {
    let day = days.options[i];
    if (day.selected) {
      results = [...results, { day: day.value }];
    }
  }
  return results;
};

const defineInterval = (target, start, end) => {
  const start_interval = padding(target.querySelector(start).value);
  const end_interval = padding(target.querySelector(end).value);
  return { start_interval, end_interval };
};

const padding = (value) => {
  return value.padStart(2, '0');
};

const selected = (e) => {
  e.preventDefault();
  document.querySelector("button[name='day']").classList.remove('selected');
  document.querySelector("button[name='night']").classList.remove('selected');
  e.target.classList.add('selected');
};

const upgradeList = (data) => {
  sendData(data);
};

const setupListener = () => {
  window.BTSwitch.switchInit('.js-switch');
  window.CreateSelect2.init();
  const newForm = document.querySelector('form[data-timeslots]');
  const day = document.querySelector("button[name='day']");
  const night = document.querySelector("button[name='night']");
  newForm.addEventListener('submit', (e) => handlerSubmit(e));
  day.addEventListener('click', (e) => selected(e));
  night.addEventListener('click', (e) => selected(e));
  eventBus.$on('newList', (data) => {
    upgradeList(data);
  });
};

const init = () => {
  try {
    setupListener();
  } catch (e) {
    errorManager(e);
  }
};

window.domiciliare = {
  init,
};
